import React, { Component, Fragment, useState } from 'react';
import { withRouter } from "react-router";
import { Table, Form, Button, Input, Select } from 'antd';
import PaginationComp from  'components/common/PaginationComp';

class QnaBoardList extends Component {
  state = {
    inputText: '',
    selBodId: '',
  };

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.disQnaBoardList(pageIdx);
  };

  onSearch = () => {
    this.props.onChangValue('schText', this.state.inputText);
    this.props.disQnaBoardList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  onFinish = (data) => {
    // console.log('bodPw ', data?.bodPw)
    this.props.disQnaBoardPwChk(this.state.selBodId, data?.bodPw);
  };

  render() {
    const {
      valCondition,
      qnaBoardList,
      pageInfo,

      onChangValue,
      onViewMode, 
      sessionLoginInfo
    } = this.props;
    const { inputText, selBodId } = this.state;
    const columns = [
      { title: 'No',  dataIndex: 'RNUM', width: 60, align: 'center' },
      { title: '제목', dataIndex: 'bodTitle', width: 'auto', align: 'left',
        render: (item, record) => { return(
          <Fragment>
            <span style={{ marginRight: 10 }}>{item}</span>
            {record?.commentsCnt > 0 // 댓글수
            && <span style={{ color: '#1890ff', fontWeight: 'bold' }}>
                [ {record?.commentsCnt} ]
              </span>}
          </Fragment>
        )}
      },
      { title: '작성자', dataIndex: 'bodMakeUserNm', width: 200, align: 'center' },
      { title: '작성일', dataIndex: 'bodMakeDate', width: 180, align: 'center' },
      { title: '조회수', dataIndex: 'bodHit', width: 100, align: 'center' },
    ];

    const PwInput = ({ value, onChange }) => {
      const [number, setNumber] = useState('');
      const onNumberChange = (e) => {
        const inputValue = e.target.value;
        const reg = /^-?\d*(\.\d*)?$/;
        if (reg.test(inputValue) || inputValue === '') {
          setNumber(inputValue)
          onChange(inputValue);
        }
      };
  
      return (
        <Input
          placeholder={"비밀번호(숫자4자리)를 입력하세요."}
          maxLength={4}
          value={value || number}
          onChange={onNumberChange}
        />
      )
    };

    if(sessionLoginInfo?.ceType !== process.env.REACT_APP_TYPE_YUJIN && selBodId) {
      return (
        <Fragment>
          <h2 className="h2_t" style={{margin: '50px'}}>비밀번호를 입력해주세요.</h2>
          <Form 
            name="passwordForm"
            onFinish={this.onFinish}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600, width: '50%', height: '50%', border:'1px solid #efefef', padding :'2rem 4rem 0.5rem', margin : '40px auto 0 auto' }}
            initialValues={{bodPw: ''}}
          >
            <Form.Item
              label="비밀번호 "
              name="bodPw"
              rules={[{ required: true, message: '비밀번호(숫자4자리)를 입력하세요.' }]}
            >
              <PwInput />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 15, span: 16 }}>
              <Button style={{margin: '0 10px'}} onClick={()=>this.setState({selBodId: ''})}>취소</Button>
              <Button type="primary" htmlType="submit">확인</Button>
            </Form.Item>
          </Form>
        </Fragment>
      )
    }

    return (
      <Fragment>
        <h2 className="h2_t">Q & A</h2>
        <div className="srch_box">
          <Select
            style={{ width: 200, marginBottom: 8 }}
            value={valCondition.selValue}
            onChange={(value)=>onChangValue('selValue', value)}
          >
            <Select.Option key={'A'}>제목</Select.Option>
            <Select.Option key={'B'}>제목+내용</Select.Option>
          </Select>

          <Input.Search 
            placeholder=""
            value={inputText}
            onChange={(e)=>this.setState({inputText: e.target.value})}
            onPressEnter={this.onPressEnter}
            onSearch={this.onSearch}
            style={{ width: 400 }}
          />
        </div>
        <div >
          <Button 
            className="buttonR"
            type="primary"
            onClick={()=>{
              onViewMode('add');
            }}
          >문의하기</Button>
        </div>
        
        <Table
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={qnaBoardList}
          pagination={false}
          onRow={(record) => {
            return {
              onClick: e => {
                e.preventDefault();
                this.setState({selBodId: record.bodId});
                if(sessionLoginInfo?.ceType === process.env.REACT_APP_TYPE_YUJIN) {
                  this.props.disQnaBoardDetail(record.bodId);
                }
              },
            };
          }}
        />
        <PaginationComp 
          pageInfo={pageInfo}
          onChange={this.onPageChange}
        />
      </Fragment>
    );
  }

}

export default withRouter(QnaBoardList);
